// _PRAIP_AKIRD stands for Predicted Risk Assuming Invasive Procedure - acute kidney injury treated with short-term dialysis

/* eslint-disable camelcase */
// noinspection UnnecessaryLocalVariableJS

import {HEALTH_FACTORS} from '../../../containers/appConstants';
import {COEFFICIENTS, BASELINES} from './eqConstants';

export const _PRAIP_AKIRD = patientHealthFactors => {
  const age = patientHealthFactors.age;
  const sex = patientHealthFactors.sex === HEALTH_FACTORS.MALE ? 1 : 0;
  const nstemi = patientHealthFactors.diagnosis === HEALTH_FACTORS.NSTEMI ? 1 : 0;
  const eGFR = patientHealthFactors.egfr;
  const haemoglobin = patientHealthFactors.hemoglobin;
  const albuminuria_mild = patientHealthFactors.albuminuria === HEALTH_FACTORS.MILD ? 1 : 0;
  const albuminuria_heavy = patientHealthFactors.albuminuria === HEALTH_FACTORS.HEAVY ? 1 : 0;
  const diabetes = patientHealthFactors.clinicalHistory.includes(HEALTH_FACTORS.DIABETES_MELLITUS) ? 1 : 0;
  const prior_invasive = patientHealthFactors.clinicalHistory.includes(HEALTH_FACTORS.PRIOR_CARDIAC_CATHETERIZATION) ? 1 : 0;

  const AEBX = COEFFICIENTS.interceptTerm +
    COEFFICIENTS.age * (age + BASELINES.age) +
    COEFFICIENTS.sex * sex +
    COEFFICIENTS.nstemi * nstemi +
    COEFFICIENTS.eGFR * (eGFR + BASELINES.eGFR) +
    COEFFICIENTS.hemo * (haemoglobin + BASELINES.hemo) +
    COEFFICIENTS.albuminuriaMild * albuminuria_mild +
    COEFFICIENTS.albuminuriaHEavy * albuminuria_heavy +
    COEFFICIENTS.diabetes * diabetes +
    COEFFICIENTS.priorInv * prior_invasive;

  const APlusEBX = Math.pow(Math.exp(Math.abs(AEBX)), Math.sign(AEBX));

  const predictedRiskInvasive = APlusEBX / (1 + APlusEBX);

  const acuteKidneyInjuryRequiringDialysis = {
    PRI: predictedRiskInvasive,
    probability: predictedRiskInvasive * 100,
    age: age,
    sex: sex,
    nstemi: nstemi,
    eGFR: eGFR,
    haemoglobin: haemoglobin,
    albuminuria_mild: albuminuria_mild,
    albuminuria_heavy: albuminuria_heavy,
    diabetes: diabetes,
    prior_invasive: prior_invasive,
    AEBX: AEBX
  };

  return acuteKidneyInjuryRequiringDialysis;
};
